export default "__VITE_ASSET__9078a02b__"